<template>
  <p>
    <router-view></router-view>
  </p>
  <div class="site_footer">
    <div style="padding: 20px 50px;">
      <el-row>
        <el-col :span="8">
          <div>
            <div class="foot_area_title">
              Hot-Line
            </div>
            <br>
            <b>0086-181 2121 7006</b>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="follow">
            <div>
              <div class="foot_area_title">
                Follow us
              </div>
              <br>
              <div class="contactUs">
                You can find us from these places: <br><br>
                E-mail:<br><a href="mailto:zhaoboya@chenxichem.com">zhaoboya@chenxichem.com</a><br>
              </div>
            </div>
            <div>
                <div class="bshare-custom bdsharebuttonbox bdshare-button-style0-16" data-bd-bind="1695426538317">
                    <div class="bsPromo bsPromo2"></div>
                </div>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="f3">
            <p>Add:<br>No.10-1006, Block B, No.116 Yingbin Ave., Xingang Park, Zhoushan<br>
            Economic Dev. Zone, (Comprehensive Bonded Zone), Beichan Township, Dinghai Dist., Zhoushan City, China (Zhejiang) Pilot Free Trade Zone</p><br>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          Copyright© 2023-2024 <br><a href="http://www.chenxichem.com/" target="_blank" style="color: #fff; margin-right: 10px;">ZHOUSHAN CHENXI NEW MATERIAL CO.,LTD. All rights reserved</a><br>
          <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #fff;">浙ICP备2023035334号-1</a><br>
          <img src="../../../assets/images/police.png" style="width: 16px; height: 16px;"/> <a href="https://beian.mps.gov.cn/#/query/webSearch?code=33090202000576" rel="noreferrer" target="_blank"  style="color: #fff;">浙公网安备33090202000576</a>
        </el-col>
      </el-row>
    </div>
  </div>
    
</template>

<script>

export default {
  name: 'AppEN',
  components: {
  }
}
</script>

<style>
</style>
  